import { Flex, Typography } from '@fuxi/eevee-ui';
import { isNil } from 'lodash-es';
import { UserCertifyType } from 'common/constants';
import EnterpriseCertifiedIcon from 'common/assets/icon/company-certification.svg';
import PersonalCertifiedIcon from 'common/assets/icon/personal-certification.svg';

import cx from './ArtistTag.module.css';
import { QualificationStatus } from 'common/types';
import QualificationTag from './QualificationTag';

type ArtistTagProps = {
  mini?: boolean;
  userCertifyType?: UserCertifyType;
  artistQualificationStatus?: QualificationStatus;
};

const ArtistTagLabel = {
  [UserCertifyType.UnCertified]: '未认证',
  [UserCertifyType.PersonalCertified]: '个人认证',
  [UserCertifyType.EnterpriseCertified]: '企业认证',
};

const ArtistTagLabelColor = {
  [UserCertifyType.UnCertified]: 'var(--color-info)',
  [UserCertifyType.PersonalCertified]: 'var(--color-success)',
  [UserCertifyType.EnterpriseCertified]: 'rgba(231, 163, 43, 1)',
};

const ArtistTagIcon = {
  [UserCertifyType.UnCertified]: <img alt="" src={PersonalCertifiedIcon} />,
  [UserCertifyType.PersonalCertified]: <img alt="" src={PersonalCertifiedIcon} />,
  [UserCertifyType.EnterpriseCertified]: <img alt="" src={EnterpriseCertifiedIcon} />,
};

const ArtistTag = ({ mini, userCertifyType, artistQualificationStatus }: ArtistTagProps) => {
  return (
    <Flex gap={mini ? 6 : 12}>
      {userCertifyType !== UserCertifyType.UnCertified && userCertifyType && (
        <Flex
          gap={6}
          alignCenter
          className={cx('artist-tag-wrapper', { mini })}
          style={{ color: ArtistTagLabelColor[userCertifyType] }}>
          {ArtistTagIcon[userCertifyType]}
          <Typography.Text ellipsis={{ tooltip: true }} style={{ color: ArtistTagLabelColor[userCertifyType] }}>
            {ArtistTagLabel[userCertifyType]}
          </Typography.Text>
        </Flex>
      )}
      {!isNil(artistQualificationStatus) && (
        <QualificationTag mini={mini} status={artistQualificationStatus!} showRequirementType={false} />
      )}
    </Flex>
  );
};

export default ArtistTag;
